import { BaseService } from './baseService';
import { PendingTasksDto } from '../types/pendingTasks';

class PendingTasksService extends BaseService<PendingTasksDto> {
  constructor() {
    super('/pending-tasks');
  }

  async getPendingTasks(signal?: AbortSignal): Promise<PendingTasksDto> {
    return (await this.getAll({}, signal))[0] ?? {
      gdprNoConsentList: [],
      documentsWithNoFileList: [],
    };
  }
}

export const pendingTasksService = new PendingTasksService();